import React from "react";
import { ReactComponent as phone } from "../../icons/phone.svg";
import { ReactComponent as arrowLeft } from "../../icons/arrow-left.svg";
import { ReactComponent as plus } from "../../icons/plus.svg";
import { ReactComponent as outstand } from "../../icons/outstand.svg";
import { ReactComponent as tickGreen } from "../../icons/tick-green.svg"; 

import { ReactComponent as calendar } from "../../icons/calendar.svg";
import { ReactComponent as card } from "../../icons/card.svg";  
import { ReactComponent as phoneChat } from "../../icons/phone-chat.svg"; 
import { ReactComponent as computer } from "../../icons/computer.svg"; 
import { ReactComponent as download } from "../../icons/download.svg"; 
import { ReactComponent as visa } from "../../icons/visa.svg"; 
import { ReactComponent as payment } from "../../icons/payment.svg"; 
import { ReactComponent as close } from "../../icons/close.svg"; 
import { ReactComponent as google } from "../../icons/google.svg"; 
import { ReactComponent as tickRoundborder } from "../../icons/tick-round-border.svg";
import { ReactComponent as diners } from "../../icons/diners.svg";
import { ReactComponent as discover } from "../../icons/discover.svg";
import { ReactComponent as maestro } from "../../icons/maestro.svg"; 
import { ReactComponent as mastercard } from "../../icons/mastercard.svg";
import { ReactComponent as applepay } from "../../icons/apple-pay.svg"; 
import { ReactComponent as googlepay } from "../../icons/google-pay.svg";
import { ReactComponent as americanExpress } from "../../icons/american-express.svg";
import { ReactComponent as spinner } from "../../icons/spinner.svg"; 
import { ReactComponent as spinnerBlue } from "../../icons/spinner-blue.svg"; 
import { ReactComponent as userThin } from "../../icons/user-thin-icon.svg"; 
import { ReactComponent as envelope } from "../../icons/envelope-icon.svg";
import { ReactComponent as closeRed } from "../../icons/close-red-icon.svg"; 
import { ReactComponent as processingClock } from "../../icons/processing-icon.svg";
import { ReactComponent as arrowDown } from "../../icons/arrow-down.svg";
import { ReactComponent as jcb } from "../../icons/newjcb.svg";
import { ReactComponent as invoice } from "../../icons/invoices.svg";
import { ReactComponent as dollar } from "../../icons/dollar.svg";
import { ReactComponent as textPay } from "../../icons/text-to-pay.svg";
import { ReactComponent as onlinePay } from "../../icons/online-payments.svg";
import { ReactComponent as bank } from "../../icons/bank.svg";
import { ReactComponent as thinDownArrow } from "../../icons/thin-down-arrow.svg";
import { ReactComponent as plaid } from "../../icons/plaid.svg";
import { ReactComponent as bankTransfer } from "../../icons/bankTransfer.svg";
import { ReactComponent as wisetackLogoRound } from "../../icons/wisetack-logo-round.svg";
import { ReactComponent as globe } from '../../icons/globe.svg';
import { ReactComponent as facebook } from '../../icons/facebook-stroke.svg';

const iconTypes = {
  phone: phone,
  globe: globe,
  facebook: facebook,
  arrowLeft: arrowLeft,
  plus: plus,
  outstand: outstand,
  tickGreen: tickGreen,
  calendar: calendar,
  card: card,
  phoneChat: phoneChat,
  computer: computer,
  download: download,
  visa: visa,
  payment: payment,
  close: close,
  google: google,
  tickRoundborder: tickRoundborder,
  diners: diners,
  discover: discover,
  maestro: maestro,
  mastercard: mastercard,
  applepay:applepay,
  googlepay:googlepay,
  americanExpress:americanExpress,
  spinner:spinner,
  spinnerBlue:spinnerBlue,
  userThin:userThin,
  envelope:envelope,
  closeRed:closeRed,
  processingClock:processingClock,
  arrowDown:arrowDown,
  jcb:jcb,
  invoice: invoice,
  dollar: dollar,
  textPay: textPay,
  onlinePay: onlinePay,
  bank: bank,
  thinDownArrow: thinDownArrow,
  plaid: plaid,
  bankTransfer:bankTransfer,
  wisetackLogoRound
};
  
  const IconComponent = ({ name, ...props }) => {
    const Icon = iconTypes[name];
    return <Icon />;
  };
  
  export default IconComponent;  